<template>
    <div class="library_wrapper">
        <div class="library">
            <div class="library_top">
                <div class="library_top_title">
                    <span>Here you can check and download all RGEA documents</span>
                    <span>Documents library</span>
                    <div class="library_top_title-block"></div>
                </div>

                <div class="library_top_search">
                    <img src="@/assets/svg/search.svg">
                    <input ref="search" type="search" placeholder="Search Document" @keyup="onInput">
                </div>
<!--                <div class="library_top_date">-->
<!--&lt;!&ndash;                    <input type="text" ref="dateInput" :class="dateInputClass" :placeholder="date" @keyup="onInputDate"/>&ndash;&gt;-->
<!--                    <span class="library_top_date_s">Date from:</span>-->
<!--                    <input @input="onInputDate" ref="dateInputFrom" type="date">-->
<!--                    <span  @input="onInputDate" class="library_top_date_s">Date to:</span>-->
<!--                    <input ref="dateInputTo" type="date">-->
<!--                </div>-->
                <!-- <div class="library_top_event">
                    <span>Event:</span>
                    <span>Homeowners meeting</span>
                    <img src="@/assets/svg/down-arrow.svg">
                </div> -->
            </div>
            <div class="library_filter">
                <div v-for="item in documentTypes" :key="item.id" class="library_filter-button" @click="onFilter(item.id)">
                    <span v-if="item.name !== 'Notices' || item.name !== 'notices'">{{ item.name }}</span>
                </div>
            </div>
            <div v-if="list" class="library_content">
                <div class="library_content_line" v-for="i in list" v-bind:key="i.id">
                    <app-library-item v-bind:data="i" class="library_content_line-item"></app-library-item>
                </div>
            </div>
            <div v-if="!isLoading" class="library_button">
                <div class="library_button-block" @click="loadMore()">
                    <span>Load more</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LibItem from './DocumentsLibratyItem';
    import DocumentLibraryServices from "../../services/DocumentLibraryServices";
    // import Input from "../../components/ui/Input";

    export default {
        components:{
            'app-library-item': LibItem
        },
        data(){
            return {
                isLoading: true,
                limit: 1,
                types: [],
                filter: '',
                list: [],
                date: '',
                dateInputClass: '',
                documentTypes: [],
                filters: {}
            }
        },
        created() {
            this.getDocumentTypes().then((response)=>{
                response.data.data.forEach(element => {
                    if(element.name !== "Notices" && element.name !== "notices"){
                       this.documentTypes.push(element);
                    }
                });
            })
        },
        mounted() {
            if(this.$refs.dateInputFrom){
               const now =  Date.now();
            const lastMonth = now - 31*24*60*60*1000;

            this.$refs.dateInputFrom.value=new Date(lastMonth).toISOString().slice(0,10);
            this.$refs.dateInputTo.value=new Date(now).toISOString().slice(0,10);

            // this.filters.dateF= this.$refs.dateInputFrom.value;
            // this.filters.dateT= this.$refs.dateInputTo.value;

            this.getTypes().then((resp)=>{
               this.types=resp.data.data
            });

            this.filters.typeID=1;
            //const str = this.$refs.dateInput.value.split(' ');

            // this.getDocuments({dateF: str[0], dateT: str[2]}).then((resp)=>{
            //     this.list=resp.data.data;
            //     this.isLoading = false;
            // })

            }
            
        },
        methods:{
            async getDocumentTypes(){
                try{
                    const responce = await DocumentLibraryServices.getDocumentsTypes();
                    return responce;
                }
                catch (e) {
                    return e;
                }
            },
            async getTypes(){
                try{
                    const responce = await DocumentLibraryServices.getTypes();
                    return responce;
                }
                catch (e) {
                    return e;
                }
            },
            async getDocuments(obj){
                try{
                    const responce = await DocumentLibraryServices.getDocuments(obj);
                    return responce;
                }
                catch (e) {
                    return e;
                }
            },
            onInput(e){
                if(e.key === 'Enter'){
                   const str = this.$refs.search.value;
                   //this.$refs.search.value ='';
                   this.isLoading =true;
                   this.filters.search = str;
                    this.getDocuments(this.filters).then((resp)=>{
                        this.list=resp.data.data;
                        this.isLoading = false;
                    });
                }
            },
            onInputDate(e) {
                if ((this.$refs.dateInputFrom.value) && (this.$refs.dateInputTo.value)) {
                    this.filters.dateF = this.$refs.dateInputFrom.value;
                    this.filters.dateT = this.$refs.dateInputTo.value;
                    this.getDocuments(this.filters).then((resp)=>{
                        this.list=resp.data.data;
                        this.isLoading = false;
                    });
                }
            },
            onFilter(f){
                this.isLoading =true;
                this.filters.typeID=f;
                this.getDocuments(this.filters).then((resp)=>{
                    this.list=resp.data.data;
                    this.isLoading = false;
                });
            },
            loadMore(){
                this.isLoading =true;
                this.limit +=1;
                this.getDocuments({...this.filters, page: this.limit}).then((resp)=>{
                    resp.data.data.forEach((i)=>{
                        this.list.push(i);
                    });
                    this.isLoading = false;
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .incorrect {
        color: red !important;
        border-bottom-color: red !important;
    }
    .first {
        @media screen and (max-width: 720px) {
            order: 0;
            width: 49% !important;
            max-width: 49% !important;
        }
    }
    .second {
        @media screen and (max-width: 720px) {
            order: 1;
            width: 49% !important;
            max-width: 49% !important;
        }
    }
    .library {
        &_wrapper {
            width: 100%;
            margin-top: 30px;
        }
        max-width: 1180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        &_top {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-end;
            @media screen and (max-width: 720px) {
                flex-wrap: wrap;
            }
            margin-bottom: 68px;
            &_title {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: start;
                @media screen and (max-width: 720px) {
                   order: 0;
                   width: 48%;
                }
                @media screen and (max-width: 480px) {
                    order: 0;
                    width: 98%;
                }
                span {
                    color: #38383a;
                    font-family: "Optimal C";
                    font-size: 30px;
                    font-weight: 400;
                    text-transform: uppercase;
                    letter-spacing: 0.07px;
                    margin-bottom: 26px;
                    &:first-child {
                        color: #adadad;
                        font-family: "Open Sans";
                        font-size: 12px;
                        font-weight: 400;
                        text-transform: uppercase;
                        letter-spacing: 0.3px;
                        margin-bottom: 23px;
                    }
                }
                &-block {
                    width: 63px;
                    height: 3px;
                    background-color: #2a9854;
                }
            }
            &_search {
                display: flex;
                align-items: center;
                flex-direction: row;
                justify-content: flex-end;
                max-width: 20%;
                margin-right: 8px;
                @media screen and (max-width: 720px) {
                    max-width: 48%;
                    width: 48%;
                    order: 0;
                }
                @media screen and (max-width: 480px) {
                    font-size: 10px;
                    margin-top: 29px;
                    justify-content: center;
                    max-width: 98%;
                    width: 98%;
                    order: 1;
                }
                img {
                    width: 15px;
                    height: 15px;
                    margin-right: 8px;
                }
                input {
                    outline: none;
                    border: none;
                    color: #aeaeb2;
                    font-family: "Optimal C";
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0.6px;
                }
            }
            &_date {
                margin-right: 8px;
                display: flex;
                flex-direction: row;
                align-items: center;
                @media screen and (max-width: 720px) {
                    margin-top: 60px;
                    order: 1;
                }
                @media screen and (max-width: 480px) {
                    order: 2;
                }
                span {

                    @media screen and (max-width: 480px) {
                        font-size: 9px;
                    }

                }
                &_s {

                    font-family: "Optimal C";
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0.6px;

                    padding-bottom: 2px;

                    white-space: nowrap;

                    color: #aeaeb2;
                    margin-right: 8px;
                    border: none;
                    cursor: default;
                }
                input {
                    border: none;
                    outline: none;
                    color: #1a924a;
                    font-family: "Optimal C";
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0.6px;
                    border-bottom: 2px solid #1a924a;
                    padding-bottom: 2px;
                    cursor: pointer;
                    white-space: nowrap;
                    width: 130px;
                }
            }
            &_event {
                display: flex;
                flex-direction: row;
                align-items: center;
                @media screen and (max-width: 720px) {
                    margin-top: 60px;
                    order: 1;
                }
                @media screen and (max-width: 480px) {
                    order: 2;
                }
                span {
                    color: #aeaeb2;
                    font-family: "Optimal C";
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0.6px;
                    margin-right: 8px;
                    cursor: pointer;
                    white-space: nowrap;
                    @media screen and (max-width: 480px) {
                        font-size: 9px;
                    }
                    &:first-child {
                        cursor: none;
                    }
                }
                img {
                    width: 8px;
                    height: 5px;
                    cursor: pointer;
                }
            }
        }
        &_filter {
            display: flex;
            width: 97%;
            margin:0 auto;
            flex-direction: row;
            flex-wrap: wrap;
            &-button {
                width: 23%;
                min-height: 30px;
                padding:10px 0;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 30px;
                 @media screen and (max-width: 720px) {
                     width:45%;
                 }
                 @media screen and (max-width: 720px) {
                     width:97%;
                 }
                cursor: pointer;
                &:nth-child(4n-3){
                    background-color: #f56a3f;
                    margin-right:2%;
                }
                &:nth-child(4n-2){
                    background-color: #2579bf;
                    margin-right:2%;
                }
                &:nth-child(4n-1){
                    background-color: #e2574c;
                    margin-right:2%;
                }
                &:nth-child(4n){
                    background-color: #83c550;
                }
                span {
                    color: #ffffff;
                    font-family: "Open Sans";
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0.35px;
                    text-align: center;
                    @media screen and (max-width: 480px) {
                        font-size: 12px;
                    }
                }
            }
        }
        &_button {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 52px;
            margin-bottom: 107px;
            &-block {
                height: 37px;
                background-color: #2a9854;
                width: 25%;
                max-width: 141px;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                span {
                    color: #ffffff;
                    font-family: "Open Sans";
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0.35px;
                    white-space: nowrap;
                }
            }
        }
        &_content {
            width: 98%;
            &_line {
                width: 100%;
                background-color: #ffffff;
                &:nth-child(2n)  {
                    background-color: #f7f7f7;
                }
            }
        }

    }
</style>